export default __webpack_public_path__ + "web/react/components/save-for-later-send-to-app-modal/images/s4l-image2.d8eab4d3db5f20f49d92e693bbdba850.png";